import { IChargePoint } from '../common/hooks/useChargePoint'

import currentUser, { CurrentUser } from './currentUser'
import hasClaimForCompany from './hasClaimForCompany'
import Claims from './claims'
import { isPartnerDomain, isUserappDomain } from './currentDomain'

const isConnectorOwner = (user: CurrentUser, chargePoint: IChargePoint) => {
    for (const connector of chargePoint.connectors) {
        if (user.id === connector.connectorUserId) return true
    }

    return false
}

const isOwnerWithEditPermission = (user: CurrentUser, chargePoint: IChargePoint) => {
    return (user.id === chargePoint.ownerId || isConnectorOwner(user, chargePoint)) && !chargePoint.ownerReadOnly
}

const isCompanyAdmin = (user: CurrentUser, chargePoint: IChargePoint) =>
    chargePoint.companyId && hasClaimForCompany(user, chargePoint.companyId, Claims.Admin)

export default function canEditChargePoint(chargePoint?: IChargePoint): boolean {
    if (isPartnerDomain) return false

    if (!chargePoint) return false

    const user = currentUser()

    if (!user) return false

    if (user.isSuperAdmin) return true

    if (isOwnerWithEditPermission(user, chargePoint)) return true

    if (isCompanyAdmin(user, chargePoint)) return true

    if (isUserappDomain && chargePoint.ownerReadOnly) return false

    return false
}
